import { useRef } from "react";

import { Messages } from "@/components/General/Messages/messages.container";

import { useMap } from "./hooks/useMap.hook";
import { StoreDirectionsComponent } from "./storeDirections.component";
import { STORE_DIRECTIONS_MESSAGE_ID } from "./storeDirections.config";
import { StoreDirectionsContextProvider } from "./storeDirections.context";

export type StoreDirectionsProps = {
    latitude: number;
    longitude: number;
    storeName: string;
};

export const StoreDirections = ({
    latitude,
    longitude,
    storeName
}: StoreDirectionsProps) => {
    const mapElementRef = useRef<HTMLDivElement>(null);

    const destination: woosmap.map.LatLngLiteral = {
        lat: latitude,
        lng: longitude
    };

    useMap(mapElementRef, destination);

    return (
        <StoreDirectionsContextProvider
            storeName={storeName}
            mapElementRef={mapElementRef}
            destination={destination}
        >
            <Messages messageid={STORE_DIRECTIONS_MESSAGE_ID} />
            <StoreDirectionsComponent ref={mapElementRef} />
        </StoreDirectionsContextProvider>
    );
};
